<template>
  <div id="home">
    <b-row no-gutters>
      <b-col cols="3" class="right-border">
        <!-- THE FILTER NAV COMPONENT -->
        <FilterNav></FilterNav>
      </b-col>
      <b-col cols="9">
        <!-- THE RESULTS COMPONENT -->
        <Results></Results>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FilterNav from "@/components/FilterNav";
import Results from "@/components/Results";

// let axios = require("axios");
import { mapActions } from "vuex";

export default {
  name: "Home",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "PIA – Participatory Image Archives",
    // all titles will be injected into this template
    description: "Synergia Project 2021–2025",
  }),
  components: {
    FilterNav,
    Results,
  },
  data() {
    return {};
  },
  created() {
    // call the mapAction 'getPosts', this will call the api in store/index.js
    this.getPosts({qp:''});
  },
  methods: {
    // import all the actions from store, they handle data asynchonous
    ...mapActions([
			// the API call
			"getPosts", 
		]),
  },
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";

.right-border {
  border-right: 0.1rem solid white;
}
</style>
